// packages/services/src/orderService.ts
import axios from 'axios';
import { getConfig } from '../config';
import { Order } from '../types/Order';
import { dataService } from './core/dataService';


export const orderService = {
   get baseService() {
          return dataService<Order>("orders");
      },

  
    updateOrderStatus: async (id: string, status: string, token?: string): Promise<Order | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.put(`${apiUrl}/orders/${id}/status`, { status }, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }
};